import { render, staticRenderFns } from "./chatHomeTeaser.vue?vue&type=template&id=5db72f3b&scoped=true"
import script from "./chatHomeTeaser.vue?vue&type=script&lang=js"
export * from "./chatHomeTeaser.vue?vue&type=script&lang=js"
import style0 from "./chatHomeTeaser.vue?vue&type=style&index=0&id=5db72f3b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db72f3b",
  null
  
)

export default component.exports